<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <!-- SIDEBAR -->
    <fuse-sidebar class="sidebar" name="operator-main-sidebar" position="left" lockedOpen="gt-md">
        <product-main-sidebar></product-main-sidebar>
    </fuse-sidebar>
    <!-- / SIDEBAR -->

    <!-- CENTER -->
    <div class="center">
        <selling-navbar></selling-navbar>

        <div class="content-card" style="overflow-y: scroll;">
            <!-- CONTENT -->
            <div id="ngx-datatable" class="page-layout simple fullwidth docs">
                <div class="content p-24">
                    <ngx-datatable
                            class="material"
                            [rows]="rows"
                            [loadingIndicator]="loadingIndicator"
                            [columnMode]="'force'"
                            [headerHeight]="48"
                            [footerHeight]="56"
                            [rowHeight]="'auto'"
                            [scrollbarH]="true"
                            [reorderable]="reorderable"
                            [selectionType]="'checkbox'"
                            [limit]="25">

                        <ngx-datatable-column [width]="48"
                                              [canAutoResize]="false"
                                              [sortable]="false">
                            <ng-template ngx-datatable-header-template let-value="value" let-allRowsSelected="allRowsSelected"
                                         let-selectFn="selectFn">
                            </ng-template>

                            <ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected"
                                         let-onCheckboxChangeFn="onCheckboxChangeFn">

                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="{{'Name'|translate}}" prop="name"></ngx-datatable-column>
<!--                        <ngx-datatable-column name="{{'Name for receipt' | translate}}">-->
<!--                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>-->
<!--                                <span *ngIf="row.nameForReceipt.length === 0" style="color: red; font-weight: bold;">-->
<!--                                    {{'Name for receipt is empty'}} - {{'No possibility to sell!'|translate}}-->
<!--                                </span>-->
<!--                                <span *ngIf="row.nameForReceipt.length > 0">{{row.nameForReceipt}}</span>-->
<!--                            </ng-template>-->
<!--                        </ngx-datatable-column>-->
                        <ngx-datatable-column name="{{'Category'|translate}}">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                <span *ngIf="row.category">
                                    {{row.category.name}}
                                </span>
                                <span *ngIf="!row.category">
                                    {{'no category'|translate}}
                                </span>
                            </ng-template>
                        </ngx-datatable-column>
<!--                        <ngx-datatable-column name="{{'Stock'|translate}}" prop="stock"></ngx-datatable-column>-->
<!--                        <ngx-datatable-column name="{{'Price net'|translate}}" prop="priceNet"></ngx-datatable-column>-->
<!--                        <ngx-datatable-column name="{{'VAT'|translate}}">-->
<!--                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>-->
<!--                                <span *ngIf="row.vatRate">-->
<!--                                    {{row.vatRate.vatName}}-->
<!--                                </span>-->
<!--                            </ng-template>-->
<!--                        </ngx-datatable-column>-->
                        <ngx-datatable-column name="{{'Price gross'|translate}}" prop="priceGross"></ngx-datatable-column>
                        <ngx-datatable-column name="{{'Actions'|translate}}" sortable="false" prop="id">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>

                                <a *appIsGranted="['Products', 'UPDATE']" routerLink="/products/edit/{{row.id}}" title="{{'Edit'|translate}}">
                                    <i class="icon-edit"></i>
                                </a>

                                <a *appIsGranted="['Products', 'READ']" routerLink="/orders/new/product/{{row.id}}" title="{{'Sell'|translate}}">
                                    <i class="icon-add_shopping_cart"></i>
                                </a>

                                <a *appIsGranted="['Products', 'READ']" routerLink="/products/stocks/{{row.id}}" title="{{'Stocks'|translate}}">
                                    <i class="icon-domain"></i>
                                </a>

                                <a *appIsGranted="['Products', 'READ']" routerLink="/products/sale-report/{{row.id}}" title="{{'Sale report'|translate}}">
                                    <i class="icon-insert_chart"></i>
                                </a>

                                <a *appIsGranted="['Products', 'UPDATE']" routerLink="/logs/{{row.id}}/Product">{{'Logs'|translate}}</a>

                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>
            </div>
        </div>
    </div>
</div>
